export const tabbarConfig = {
  follow: [
    { path: '/home', name: 'home', title: '首页', icon: 'home-o' },
    { path: '/customer', name: 'customerList', title: '客户', icon: 'friends-o' },
    { path: '/message', name: 'messageList', title: '消息', icon: 'bell' },
    { path: '/profile', name: 'profile', title: '我的', icon: 'user-o' }
  ],
  assign: [
    { path: '/home', name: 'home', title: '首页', icon: 'home-o' },
    { path: '/assign', name: 'assignFollowing', title: '跟进情况', icon: 'todo-list-o' },
    { path: '/admin/stats', name: 'adminStats', title: '数据统计', icon: 'chart-trending-o' },
    { path: '/message', name: 'messageList', title: '消息', icon: 'bell' },
    { path: '/profile', name: 'profile', title: '我的', icon: 'user-o' }
  ],
  system: [
    { path: '/home', name: 'home', title: '首页', icon: 'home-o' },
    { path: '/admin/audit', name: 'adminAudit', title: '审核', icon: 'orders-o' },
    { path: '/admin/stats', name: 'adminStats', title: '统计', icon: 'chart-trending-o' },
    { path: '/message', name: 'messageList', title: '消息', icon: 'bell' },
    { path: '/profile', name: 'profile', title: '我的', icon: 'user-o' }
  ],
  brand: [
    { path: '/home', name: 'home', title: '首页', icon: 'home-o' },
    { path: '/admin/audit', name: 'adminAudit', title: '审核', icon: 'orders-o' },
    { path: '/admin/stats', name: 'adminStats', title: '统计', icon: 'chart-trending-o' },
    { path: '/message', name: 'messageList', title: '消息', icon: 'bell' },
    { path: '/profile', name: 'profile', title: '我的', icon: 'user-o' }
  ],
  store: [
    { path: '/home', name: 'home', title: '首页', icon: 'home-o' },
    { path: '/admin/audit', name: 'adminAudit', title: '审核', icon: 'orders-o' },
    { path: '/admin/customer', name: 'adminCustomer', title: '客户', icon: 'friends-o' },
    { path: '/message', name: 'messageList', title: '消息', icon: 'bell' },
    { path: '/profile', name: 'profile', title: '我的', icon: 'user-o' }
  ]
}

export const getTabbarItems = (role) => {
  return tabbarConfig[role] || tabbarConfig.follow
}

export const tabbarItems = [
  { path: '/home', name: 'home', title: '首页', icon: 'home-o' },
  { path: '/customer', name: 'customerList', title: '客户', icon: 'friends-o' },
  { path: '/message', name: 'messageList', title: '消息', icon: 'bell' },
  { path: '/profile', name: 'profile', title: '我的', icon: 'user-o' }
]
